export default __webpack_public_path__ + "static/media/sporty.0ec759b6.png";